export const regionConstants = {
    FETCH_COUNTRY_JSON: 'FETCH_COUNTRY_JSON',
    FETCH_PROCESSED_REGIONS: 'FETCH_PROCESSED_REGIONS',
    FETCH_REGION_SETTINGS_JSON: 'FETCH_REGION_SETTINGS_JSON',
    FETCH_PROCESSED_INTERNATIONAL_REGIONS: 'FETCH_PROCESSED_INTERNATIONAL_REGIONS',
};
